import React, { FC } from "react";
import { DialogTitle, LinearProgress, TitleText } from "@evergis/ui";

import { ModalDialog } from "../ModalDialog";
import { DialogContent } from "./styled";

type DialogConstants = {
  maxWidth?: string;
  title?: React.ReactNode;
};

type SimpleDialogFallbackProps = {
  context?: DialogConstants;
};

export const SimpleDialogFallback: FC<SimpleDialogFallbackProps> = ({ context = {} }) => {
  const { title, maxWidth } = context;

  return (
    <ModalDialog maxWidth={maxWidth}>
      {title && (
        <DialogTitle>
          <TitleText>{title}</TitleText>
        </DialogTitle>
      )}
      <DialogContent>
        <LinearProgress />
      </DialogContent>
    </ModalDialog>
  );
};
